import { useProductDayTripPlanI18nFormModelContext } from "../../../../../../model";
import { useProductExistingDayTripPlanI18nFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel } = useProductDayTripPlanI18nFormModelContext();
	const { onUpdate } = useProductExistingDayTripPlanI18nFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onUpdate,
	};
};
